<template>
  <div>
      <Header title="目标课程评价" type="0" route="/student/evaluateGoal" ></Header>
      <div class="tittleDiv">
         <div class="list-head">
          <p>{{baseData.kcmc}}</p>
          <ul>
            <li>上课老师：{{baseData.skls}}</li>
            <li>完成状态：{{baseData.issave=='1'?'已评':'未评'}}（{{baseData.issubmit=='1'?'已提交':'未提交'}}）</li>
          </ul>
         </div>
      </div>
      <div class="evaluate_content">

        <div v-for="(item, index) in zbList" :key="index">
             <div style="width: 100%;">
              <p>{{item.kcmb}}</p>  
              <van-radio-group v-model="zbIndexList[index].radioName"  :disabled="baseData.issubmit=='1'?true:false"   class="w-d-radio-group">
                  <van-cell-group>
                    <van-cell title="完全未达成" clickable  @click="radioClick(index,0)">
                      <template #right-icon>
                        <van-radio name="0" >
                          <template #icon="props">
                            <img class="img-icon" :src="props.checked||item.selectIndex=='0' ? activeIcon : inactiveIcon" />
                          </template>
                        </van-radio>
                      </template>
                    </van-cell>
                    <van-cell title="极少部分达成" clickable @click="radioClick(index,1)" >
                      <template #right-icon>
                        <van-radio name="1" >
                          <template #icon="props">
                            <img class="img-icon" :src="props.checked||item.selectIndex=='1' ? activeIcon : inactiveIcon" />
                          </template>
                        </van-radio>
                      </template>
                    </van-cell>
                    <van-cell title="少部分达成" clickable @click="radioClick(index,2)"  >
                      <template #right-icon>
                        <van-radio name="2" >
                          <template #icon="props">
                            <img class="img-icon" :src="props.checked||item.selectIndex=='2' ? activeIcon : inactiveIcon" />
                          </template>
                        </van-radio>
                      </template>
                    </van-cell>
                    <van-cell title="基本达成" clickable @click="radioClick(index,3)"  >
                      <template #right-icon>
                        <van-radio name="3" >
                          <template #icon="props">
                            <img class="img-icon" :src="props.checked||item.selectIndex=='3' ? activeIcon : inactiveIcon" />
                          </template>
                        </van-radio>
                      </template>
                    </van-cell>
                    <van-cell title="大部分达成" clickable @click="radioClick(index,4)"  >
                      <template #right-icon>
                        <van-radio name="4" >
                          <template #icon="props">
                            <img class="img-icon" :src="props.checked||item.selectIndex=='4' ? activeIcon : inactiveIcon" />
                          </template>
                        </van-radio>
                      </template>
                    </van-cell>

                    <van-cell title="全部达成" clickable @click="radioClick(index,5)"  >
                      <template #right-icon>
                        <van-radio name="5" >
                          <template #icon="props">
                            <img class="img-icon" :src="props.checked||item.selectIndex=='5' ? activeIcon : inactiveIcon" />
                          </template>
                        </van-radio>
                      </template>
                    </van-cell>
                  </van-cell-group>
                </van-radio-group>
             </div>
             
        </div>


        </div>

        <div class="eva-body">
        <p>目标达成不理想原因和提高目标达成度的建议：</p>
        <keep-alive>
				<textarea
				  placeholder="请点击填写"
				  v-model="evaText"
				  maxlength="400"
          :disabled="baseData.issubmit=='1'?true:false"
          
				></textarea>
			  </keep-alive>
        <div class="eva-body-ts"><span>最多400字符</span></div>
        <div class="grey-contain_div" ></div>
      </div>
        <div class="grey-contain_div" ></div>
      <div class="history-btn" v-if="baseData.issubmit!='1'">
        <button @click="submintPjData('0')">保存</button>
        <button @click="submintPjData('1')">提交</button>
      </div>
  </div>
</template>

<script>
  import {Api} from '../../../utils/axios'
  const icon1 = require('@/assets/images/assessment/check-white.svg')
  const icon2 = require('@/assets/images/assessment/checked.svg')
  export default {
    data(){
      return{
        mb1:'0',
        radio:'1',
        inactiveIcon: icon1,
        activeIcon: icon2,
        evaluateList:[],
        warning:'',
        baseData:[],
        evaText:'',
        zbList:[],
        zbIndexList:[],
      }
    },
    methods:{
      async submintPjData(submittype){
        //if(this.evaText.trim()==''){
          //this.$toast("建议不能为空！");
         // return;
       // }
        if(this.zbIndexList.length<1){
           this.$toast("请先联系管理员设置评价目标！");
            return;
        }
        let zbRustr = "";
        for(let i=0;i<this.zbIndexList.length;i++){
          if(this.zbIndexList[i].radioVal==-1){
            this.$toast("还有评价目标未选完！");
            return;
          }
          if(i==this.zbIndexList.length-1){
            zbRustr+=this.zbIndexList[i].radioVal;
          }else{
            zbRustr+=this.zbIndexList[i].radioVal+"@#";
          }
          
        }
        const params = {
          jx0404id:this.baseData.jx0404id,
          evaText:this.evaText,
          zbRustr:zbRustr,
          type:submittype
        };
        const res = await Api.submitEvaluateGloal(params);
        if(res.code=='1'){
          this.$toast("操作成功！");
          setTimeout(() => {
          this.$router.push({
             path:'/student/evaluateGoal',
            });
            }, 1500);
            }
      },
      async findEvaluatDate(){
        const params = {
          jx0404id:this.baseData.jx0404id,
        };
        const res = await Api.findEvaluatDate(params);
        if(res.code=='1'){
          this.zbList = res.data.zdData;
          if(this.zbList.length==0){
            this.$toast("该课程没有设置评价目标，请先联系管理员设置评价目标！");
            setTimeout(() => {
              this.$router.push({
                  path: '/student/evaluateGoal',
              });
          },2000)
           
             return;
          }
          for(let i=0;i<this.zbList.length;i++){
            let radioName = 'radio_'+i;
            let radioVal = this.zbList[i].selectIndex;
            this.zbIndexList.push({'radioName':radioName,'radioVal':radioVal})
          }
          this.evaText = res.data.ydData;
        }

      },
      radioClick(index,val){
        if(this.baseData.issubmit=='1'){
          return;
        }
        this.zbList[index].selectIndex = -1;
        this.zbIndexList[index].radioVal = val;
      }
    },
    created(){
      this.$store.state.evaOptCheck = [];
      this.baseData = JSON.parse(this.$route.query.dataObj);
      this.findEvaluatDate()
    },
  }
</script>

<style lang="less" scoped>
.tittleDiv{
  position: fixed;
  top: 50px;
  padding: 2% 5% 2%;
	background-color: #ffffff;
	height: 90px;
  width: 90%;
  z-index: 99999;
	.list-head {
	  height: 100%;
	  background-image: url("../../../../static/image/head.png");
	  background-size: 100% 100%;
	  background-repeat: no-repeat;
	  display: flex;
	  padding: 3% 5%;
	  box-sizing: border-box;
	  position: relative;
	  flex-direction: column;
    p {
		height: 22px;
		font-family: PingFangSC-Medium;
		font-size: 18px;
		color: #fff;
		letter-spacing: 0;
		line-height: 22px;
		font-weight: 500;
		margin-bottom: 2%;
    text-overflow: ellipsis;
    overflow: hidden;
	  }
    ul li {
		  height: auto;
		  font-family: PingFangSC-Regular;
		  font-size: 14px;
		  color: #fff;
		  letter-spacing: 0;
		  margin-bottom: 1%;
		  opacity: 0.8;
		}
  }
}
.grey-contain{display: flex;align-items: center;}
.grey-contain h4{overflow: hidden;white-space: nowrap;text-overflow: ellipsis;line-height: 22px;}
  .grey-contain button{background-color: @attendance-background-color-1;border-radius: 3px;color: @attendance-color-3;height: 45px;width: 70px;}
  .grey-contain .contain-txt1{line-height: 17px;}
  .grey-contain  p{margin-bottom: 2px;}
  .delay-btn{position: absolute;bottom: 20px;width: 100%;text-align: center;}
  .delay-btn button{background-color: @attendance-background-color-7;color: @attendance-background-color-1;padding: 11px 0;width: 90%;border-radius: 3px;}
  .history{border-radius: 3px;background-color: @attendance-background-color-13;color: @attendance-color-3;height: 45px;width: 70px;display: flex;flex-direction: column;align-items: center;justify-content: center;}
  .history h1{font-size: 16px;font-weight: 400;}
  .history p{font-size: 10px;}
  .eva-body{
    padding: 3% 5% 0;
    bottom: 90px;
    width: 95%;
    height: 200px;
    padding-top: 0;
    p{
      font-family: PingFangSC-Medium;
      color: #151618;
      font-size: 15px;
      font-weight: 600;
      line-height: 25px;
    }
    span {
      color: @attendance-color-2;
      position: relative;
      bottom: 0px;
      right: 10px;
      color: red;
      font-size: 12px;
   }
   .eva-body-ts{
     text-align: right;
     padding: 3% 5% 0;
     padding-top:0;
   }
  }
  .history-btn{position: fixed;bottom: 0;width: 100%;background-color: @attendance-color-3;text-align: center;padding: 0 10px;box-sizing: border-box;height: 85px;}
  .history-btn button{width: 40%;background-color: @attendance-background-color-7;color: @attendance-background-color-1;margin:20px 0;border-radius: 3px;padding: 11px 0}
  .grey-contain_div{display: flex;align-items: center;background-color: white;height: 85px;}

 .eva-body textarea {
   width: 95%;
   padding: 10px;
   background-color: @attendance-background-color-6;
   border-radius: 3px;
   box-sizing: border-box;
   color: @attendance-color-1;
   height: 85%;
   padding-bottom: 15px;
   position: relative;
 }
 .evaluate_content {
    margin-top: 150px;
    font-family: PingFangSC;
    padding: 20px;
    padding-top: 5px ;
    word-wrap: break-word;
}
 .evaluate_content > div {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: @attendance-background-color-10;
    padding: 10px 20px;
    box-sizing: border-box;
    color: @attendance-color-2;
    margin-bottom: 15px;
    border-radius: 5px;
    position: relative;
}
.evaluate_content > div::after {
    position: absolute;
    content: '';
    background-color: @attendance-background-color-1;
    width: 3px;
    left: 0;
    border-radius: 5px 0 0 5px;
    height: 100%;
}
.evaluate_content > div p {
    color: @attendance-color-2;
    font-size: 15px;
    line-height: 17px;
    margin-bottom: 2px;
    font-family: PingFangSC-Medium;
    color: #151618;
}
.evaluate_content > div h4 {
    color: @attendance-color-1;
    font-size: 16px;
    line-height: 22px;
    margin-bottom: 4px;
}
 .evaluate_content div .icon_right {
    height: 15px;
    width: 15px;
    background: url(../../../../static/img/arrow.png) center center no-repeat;
    background-size: contain;
}


.w-d-radio-group {
    .img-icon {
      width: 18px;
      height: 18px;
    }
    /deep/.van-cell {
      color: #212f6e;
      padding: 6px 12px;
      font-size: 14px;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/student/Evaluate/teachEvaluateGoal.vue